<template>
  <svg class="call-hint-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="call-hint-icon__background" d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"/>
      <path class="call-hint-icon__round" d="M12.5 12.2674C12.5 7.50004 20 7.50012 20 12.2673C20 14.5 18.5 15.9426 17 16.4426C15.5 16.9426 15.5 19.5 15.5 19.5" stroke-width="1.5" stroke-linecap="round"/>
      <path class="call-hint-icon__point" d="M16.5 23C16.5 23.5523 16.0523 24 15.5 24C14.9477 24 14.5 23.5523 14.5 23C14.5 22.4477 14.9477 22 15.5 22C16.0523 22 16.5 22.4477 16.5 23Z" />
  </svg>
</template>

<script>
export default {
  name: 'PanoramaCallHintIcon'
}
</script>

<style lang="scss" scoped>
.call-hint-icon {
  &__background {
    fill: var(--panorama-background-color);
  }
  &__round {
    stroke: var(--panorama-text-color);
  }
  &__point {
    fill: var(--panorama-text-color);
  }
}
</style>
